import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { version } from '../../../package.json';
import { AppConfig } from './app-config';

// based on https://juristr.com/blog/2018/01/ng-app-runtime-config/
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: AppConfig;

  constructor(private http: HttpClient) {}

  loadAppConfig(): Promise<AppConfig> {
    return this.http
      .get('/assets/data/app-config.json?v=' + version)
      .toPromise()
      .then(data => {
        const config: { [key: string]: any } = <{ [key: string]: string }>data;
        this.appConfig = {
          accessTokenExpiringNotificationTime: Number(
            config['AccessTokenExpiringNotificationTime']
          ),
          accessTokenLifetime: Number(config['AccessTokenLifetime']),
          checkSessionInterval: Number(config['checkSessionInterval']),
          cookieDaysToLive: Number(config['cookieDaysToLive']),
          dokumentWebUrl: config['dokumentWebUrl'],
          enableEksternSystemIntegration: this.booleanFromString(
            config['enableEksternSystemIntegration']
          ),
          environmentBannerColor: config['environmentBannerColor'],
          environmentDescription: config['environmentDescription'],
          environmentLong: config['environmentLong'],
          geoServiceTimeout: Number(config['geoServiceTimeout']),
          geoServiceSearchUrl: config['geoServiceSearchUrl'],
          geoServiceSearchToken: config['geoServiceSearchToken'],
          adressevaelgerToken: config['adressevaelgerToken'],
          identityServerClientId: config['identityServerClientId'],
          identityServerUrl: config['identityServerUrl'],
          linkToPublicWebUrl: config['linkToPublicWebUrl'],
          showLinkToPublicWeb: this.booleanFromString(config['showLinkToPublicWeb']),
          operatingStatusCookieHoursToLive: Number(config['operatingStatusCookieHoursToLive']),
          publicApiUrl: config['publicApiUrl'],
          refreshOperatingStatusIntervalSeconds: Number(
            config['refreshOperatingStatusIntervalSeconds']
          ),
          showEnvironmentBanner: this.booleanFromString(config['showEnvironmentBanner']),
          silentRequestTimeout: Number(config['silentRequestTimeout']),
          enableStyleGuide: this.booleanFromString(config['enableStyleGuide']),
          applicationInsightsFrontend: config['applicationInsightsFrontend'],
          datafordeler: config['datafordeler'],
        };
        return this.appConfig;
      });
  }

  getConfig(): AppConfig {
    return this.appConfig;
  }

  private booleanFromString(text: string): boolean {
    return text.toLowerCase() === 'true';
  }
}
